import axios from 'axios';
import { ELASTIC_SEARCH_CAMPAIGNS_INDEX } from '../firebase'
import store from '../store'
import router from '../router'

const searchCampaigns = (searchData) => {
    const page = parseInt(router.currentRoute.query.page) || 1
    const PER_PAGE = 12
    searchData.from = (page - 1) * PER_PAGE
    searchData.size = PER_PAGE
    store.commit('SET', ['searchLoading', true])

    return axios
        .post(`https://search.crossprom.com/${ELASTIC_SEARCH_CAMPAIGNS_INDEX}/_search`, searchData)
        .then(res => res.data)
        .then(
            (data) => {
                if (page === 1) {
                    store.commit('SET', ['searchResults', []])
                }

                store.commit('SET', ['total', data.hits.total.value])
                store.commit(
                    'SET',
                    [
                        'searchResults',
                        [
                            ...store.state.searchResults,
                            ...data.hits.hits.map(
                                (entry) => entry._source
                            )
                        ]
                    ],
                )
            }
        )
        .catch(e => {
            console.log(e)
            console.log('error loading search results')
        })
        .finally(() => store.commit('SET', ['searchLoading', false]))
}

export default searchCampaigns